export default {
  browse: {
    title: "Esplora",
    sections: {
      advancedTools: "Strumenti avanzati",
      freeTools: "Strumenti gratuiti",
    },
    gamesOfPeriod: "Partite del {{period}}",
    periods: {
      day: "giorno",
      week: "settimana",
    },
    gameCount_one: "{{count}} partita",
    gameCount_other: "{{count}} partite",
  },
};